export default class Logger {
	logError(error) {
		console.error("efox.premiumbonus error:", error);
	}

	logInfo(info) {
		console.info("efox.premiumbonus info:", info);
	}
}